import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'
import { fetchPath } from '../config/defPath';

type HtmlDrupal = {
  format: string
  value: string
}

type GeneralConfigState = {
  popups: {
    copy: HtmlDrupal
    url: string
    key: string
  }[]
  video: string,
  menu: Array<any>| {
    [key: string]: {
      active: number,
      icon: string,
      name: string,
      url: string
    }
  }
  cart: {
      enabled: 1 | 0
      btn1: string
      btn2: string
      whatsapp: string
      btn1_icon: string
      btn2_icon: string
      whatsapp_icon: string
  } | null
  code:  {
    code: string
    description: HtmlDrupal
  } | null

  getGeneralConfig: () => Promise<void>
}

export const useGeneralConfig = create<GeneralConfigState>()(persist((set, get) => ({
  cart: null,
  code: null,
  popups: [],
  video: 'INIT',
  questions: [],
  menu: [],
  getGeneralConfig: async () => {
    try {
      const response = await fetch(`${fetchPath}/aguila/loyalty/get-general-config`);
      const data: GeneralConfigState = await response.json();
      set({ ...data });
    } catch (error) {
      console.error(error);
    }
  },
}), { name: 'general-estadio', storage: createJSONStorage(() => sessionStorage) }));
